import { render, staticRenderFns } from "./NavMenuBusiness.vue?vue&type=template&id=9668ff74&scoped=true"
import script from "./NavMenuBusiness.vue?vue&type=script&lang=js"
export * from "./NavMenuBusiness.vue?vue&type=script&lang=js"
import style0 from "./NavMenuBusiness.vue?vue&type=style&index=0&id=9668ff74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9668ff74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VList,VListItem})
